import { SystemState } from '../system/SystemState';

export const complianceOverview = (state: SystemState) =>
  state.compliance.overview;

export const compliancePeriods = (state: SystemState) =>
  state.compliance.periods;
